import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { isNumber, isString, extend, template, cloneDeep, defaults, pick, merge, clone, isObject, assign, isBoolean, isDate, isFunction, filter, values, omitBy, map as map$1 } from 'lodash-es';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map, tap, mergeMap } from 'rxjs/operators';
import { ReplaySubject, of, throwError } from 'rxjs';
import { Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * Returns an instance object with `_pk` and `id` fields
 *
 * @param  instance
 * @returns object with `_pk` and `id` fields
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
const _normalizeInstance = (instance) => {
    if (instance === null) {
        return { _pk: null, id: null };
    }
    else if (isNumber(instance)) {
        return { _pk: instance, id: instance };
    }
    else if (isString(instance)) {
        return { _pk: instance, id: instance };
    }
    else if (instance._pk) {
        return instance;
    }
    else if (instance.id) {
        instance._pk = instance.id;
        return instance;
    }
    return { _pk: null, id: null };
};
const ɵ0$1 = _normalizeInstance;
const REST_ADAPTER_CONFIG = new InjectionToken("adapter.resturl.config");
class DSRestUrlAdapter {
    constructor(_config = null) {
        this._config = _config;
        if (this._config === null) {
            this._config = { basePath: "/${instance.MODEL_NAME}" };
        }
    }
    create(instance, createParams = {}) {
        return this._adapt(instance, this._config.createPath, this._config.basePath, createParams);
    }
    list(listParams) {
        return this._adapt(null, this._config.listPath, this._config.basePath, listParams);
    }
    retrieve(instance, retrieveParams) {
        return this._adapt(instance, this._config.retrievePath, this._config.basePath + "/${ instance._pk }", retrieveParams, {}, true);
    }
    update(instance, partial, updateParams) {
        let path = this._config.updatePath;
        if (!path) {
            path = this._config.retrievePath;
        }
        return this._adapt(instance, path, this._config.basePath + "/${ instance._pk }", updateParams, {}, true);
    }
    destroy(instance, destroyParams) {
        let path = this._config.destroyPath;
        if (!path) {
            path = this._config.retrievePath;
        }
        return this._adapt(instance, path, this._config.basePath + "/${ instance._pk }", destroyParams, {}, true);
    }
    list_action(action, listActionParams) {
        let path = this._config.listActionPath;
        if (!path) {
            if (this._config.listPath) {
                path = this._config.listPath + "/${ params.action }";
            }
        }
        return this._adapt(null, path, this._config.basePath + "/${ params.action }", listActionParams, { action });
    }
    detail_action(instance, action, detailActionParams) {
        let path = this._config.detailActionPath;
        if (!path) {
            if (this._config.retrievePath) {
                path = this._config.retrievePath + "/${ params.action }";
            }
        }
        return this._adapt(instance, path, this._config.basePath + "/${ instance._pk}/${ params.action }", detailActionParams, { action }, true);
    }
    /**
     * Provides path replacement for url, using instance and context data.
     * Uses lodash template syntax : '/api/${ instance.MODEL_NAME }/<%= instance.id %>'
     *
     * @param path
     * @param instance accessible with `instance` key in template
     * @param context accessible with `context` key in template
     * @param params accessible with `params` key in template
     */
    _path_replace(path, instance, context = {}, params = {}) {
        const options = extend({}, { params }, { instance }, { context });
        path = template(path)(options);
        if (this._config.trailingSlash) {
            if (path[path.length - 1] !== "/") {
                path += "/";
            }
        }
        return path;
    }
    _adapt(instance, specificPath, genericPath, params = {}, pathParams = {}, mustHaveId = false) {
        let headers = {};
        let query = {};
        let context = {};
        if (params) {
            if (params.headers) {
                headers = cloneDeep(params.headers);
            }
            if (params.query) {
                query = cloneDeep(params.query);
            }
            if (params.context) {
                context = cloneDeep(params.context);
            }
        }
        const inst = _normalizeInstance(instance);
        if (mustHaveId && inst._pk === null) {
            return null;
        }
        if (specificPath) {
            return {
                path: this._path_replace(specificPath, inst, context, pathParams),
                headers,
                query
            };
        }
        else {
            return {
                path: this._path_replace(genericPath, inst, context, pathParams),
                headers,
                query
            };
        }
    }
}
DSRestUrlAdapter.ɵfac = function DSRestUrlAdapter_Factory(t) { return new (t || DSRestUrlAdapter)(ɵngcc0.ɵɵinject(REST_ADAPTER_CONFIG, 8)); };
DSRestUrlAdapter.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestUrlAdapter, factory: DSRestUrlAdapter.ɵfac });
DSRestUrlAdapter.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [REST_ADAPTER_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestUrlAdapter, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [REST_ADAPTER_CONFIG]
            }] }]; }, null); })();
class DSRestUrlAdapterProvider {
    constructor(_config = null) {
        this._config = _config;
    }
    withConfig(params = null) {
        return new DSRestUrlAdapter(params || this._config);
    }
}
DSRestUrlAdapterProvider.ɵfac = function DSRestUrlAdapterProvider_Factory(t) { return new (t || DSRestUrlAdapterProvider)(ɵngcc0.ɵɵinject(REST_ADAPTER_CONFIG, 8)); };
DSRestUrlAdapterProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestUrlAdapterProvider, factory: DSRestUrlAdapterProvider.ɵfac });
DSRestUrlAdapterProvider.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [REST_ADAPTER_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestUrlAdapterProvider, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [REST_ADAPTER_CONFIG]
            }] }]; }, null); })();

class DSTokenAuthentication {
    constructor() {
        this._authenticated = false;
    }
    authenticate(token, header = "X-Token") {
        this._token = token;
        this._header = header.toLowerCase();
        this._authenticated = true;
    }
    anonymous() {
        this._token = null;
        this._header = null;
        this._authenticated = false;
    }
    setAuthHeaders(headers) {
        if (this._authenticated) {
            headers[this._header] = this._token;
        }
        return headers;
    }
    setAuthContent(content) {
        return content;
    }
    setAuthParams(params) {
        return params;
    }
}
DSTokenAuthentication.ɵfac = function DSTokenAuthentication_Factory(t) { return new (t || DSTokenAuthentication)(); };
DSTokenAuthentication.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSTokenAuthentication, factory: DSTokenAuthentication.ɵfac });
DSTokenAuthentication.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSTokenAuthentication, [{
        type: Injectable
    }], function () { return []; }, null); })();

class DSJsonParser {
    parse(response) {
        return JSON.parse(response.body);
    }
}
DSJsonParser.ɵfac = function DSJsonParser_Factory(t) { return new (t || DSJsonParser)(); };
DSJsonParser.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSJsonParser, factory: DSJsonParser.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSJsonParser, [{
        type: Injectable
    }], null, null); })();

class DSJsonRenderer {
    prepare(options) {
        if (!options.headers) {
            options.headers = {};
        }
        options.headers["content-type"] = "application/json";
        return options;
    }
    render(data) {
        return JSON.stringify(data);
    }
}

const DS_REST_BACKEND_PARSER = new InjectionToken("ds.rest.backend.parser");
const DS_REST_BACKEND_RENDERER = new InjectionToken("ds.rest.backend.renderer");
const DS_REST_BACKEND_AUTHENTICATOR = new InjectionToken("ds.rest.authenticator");
const DS_REST_BACKEND_CONFIG = new InjectionToken("backend.rest.config");
/**
 * Makes data requests to a REST API.
 */
class DSRestBackend {
    constructor(parser, renderer, authentication, _config, _http) {
        this.parser = parser;
        this.renderer = renderer;
        this.authentication = authentication;
        this._config = _config;
        this._http = _http;
        this._defaultHeaders = {};
        this._defaultParams = {};
        if (!this.parser) {
            this.parser = new DSJsonParser();
        }
        if (!this.renderer) {
            this.renderer = new DSJsonRenderer();
        }
        if (!this.authentication) {
            this.authentication = new DSTokenAuthentication();
        }
        if (this._config && this._config.headers) {
            this.setDefaultHeaders(this._config.headers);
        }
    }
    retrieve(identifier, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        return this._http
            .request("get", this.getRequestUrl(identifier), options).pipe(map((response) => this.parser.parse(response)));
    }
    list(identifier, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        return this._http
            .request("get", this.getRequestUrl(identifier), options)
            .pipe(map((response) => this.parser.parse(response)));
    }
    create(identifier, values, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        options.body = this.renderer.render(values);
        return this._http
            .request("post", this.getRequestUrl(identifier), options)
            .pipe(map((response) => this.parser.parse(response)));
    }
    update(identifier, values, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        options.body = this.renderer.render(values);
        return this._http
            .request("put", this.getRequestUrl(identifier), options)
            .pipe(map((response) => this.parser.parse(response)));
    }
    partial_update(identifier, values, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        options.body = this.renderer.render(values);
        return this._http
            .request("patch", this.getRequestUrl(identifier), options)
            .pipe(map((response) => this.parser.parse(response)));
    }
    destroy(identifier, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        options.observe = "response";
        return this._http
            .request("delete", this.getRequestUrl(identifier), options)
            .pipe(map((response) => {
            if (response.status !== 204) {
                return this.parser.parse(response);
            }
            else {
                return null;
            }
        }));
    }
    action(identifier, method, values = null, params = {}) {
        let options = this.getRequestOptions(identifier);
        options = this.renderer.prepare(options);
        if (values) {
            options.body = this.renderer.render(values);
        }
        return this._http.request(method, this.getRequestUrl(identifier), options)
            .pipe(map((response) => this.parser.parse(response)));
    }
    /**
     * Set defaults headers for this backend.
     *
     * @param headers Object headers
     */
    setDefaultHeaders(headers) {
        for (const h of Object.keys(headers)) {
            this._defaultHeaders[h] = headers[h];
        }
    }
    /**
     * Set defaults params for this backend.
     *
     * @param params Object params
     */
    setDefaultParams(params) {
        for (const h of Object.keys(params)) {
            this._defaultParams[h] = params[h];
        }
    }
    /**
     * Compute request headers.
     *
     * @param identifier Rest detail
     * @returns Object Headers dict
     */
    getRequestHeaders(identifier) {
        const headers = identifier.headers || {};
        for (const h of Object.keys(this._defaultHeaders)) {
            if (!headers[h]) {
                headers[h] = this._defaultHeaders[h];
            }
        }
        this.authentication.setAuthHeaders(headers);
        return headers;
    }
    /**
     * Compute request query string (search).
     *
     * @param identifier Rest detail
     * @returns Object Url search params option
     */
    getRequestParams(identifier) {
        const params = {};
        const rawquery = identifier.query || {};
        for (const p of Object.keys(this._defaultParams)) {
            params[p] = this._defaultParams[p];
        }
        for (const param of Object.keys(rawquery)) {
            params[param] = rawquery[param];
        }
        this.authentication.setAuthParams(params);
        return params;
    }
    /**
     * Compute request options (path, search, headers)
     *
     * @param identifier
     * @returns Request options
     */
    getRequestOptions(identifier) {
        return {
            observe: "response",
            responseType: "text",
            headers: this.getRequestHeaders(identifier),
            params: this.getRequestParams(identifier)
        };
    }
    /**
     * Compute request url using config and detail.
     *
     * @param identifier
     * @returns url
     */
    getRequestUrl(identifier) {
        if (!this._config) {
            return identifier.path;
        }
        if (this._config.url) {
            return this._config.url + identifier.path;
        }
        else {
            // SEE: is config.path needed ?
            return (this._config.scheme || "http") + "://" +
                this._config.host + ":" +
                (this._config.port || "80") +
                identifier.path;
        }
    }
}
DSRestBackend.ɵfac = function DSRestBackend_Factory(t) { return new (t || DSRestBackend)(ɵngcc0.ɵɵinject(DS_REST_BACKEND_PARSER, 8), ɵngcc0.ɵɵinject(DS_REST_BACKEND_RENDERER, 8), ɵngcc0.ɵɵinject(DS_REST_BACKEND_AUTHENTICATOR, 8), ɵngcc0.ɵɵinject(DS_REST_BACKEND_CONFIG, 8), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
DSRestBackend.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestBackend, factory: DSRestBackend.ɵfac });
DSRestBackend.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_BACKEND_PARSER,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_BACKEND_RENDERER,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_BACKEND_AUTHENTICATOR,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_BACKEND_CONFIG,] }] },
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestBackend, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_BACKEND_PARSER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_BACKEND_RENDERER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_BACKEND_AUTHENTICATOR]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_BACKEND_CONFIG]
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();

const COLLECTION_SETUP_NAMES = [
    "adapter", "adapter_class", "adapter_provider", "adapter_config",
    "backend", "backend_class", "backend_provider", "backend_config",
    "serializer", "serializer_class", "serializer_provider", "serializer_config",
    "persistence", "persistence_class", "persistence_provider", "persistence_config",
    "paginator", "paginator_class", "paginator_provider", "paginator_config",
    "filter", "filter_class", "filter_provider", "filter_config",
    "sorter", "sorter_class", "sorter_provider", "sorter_config", "datasources"
];

/**
 * Base class for setup.
 * Provides services instanciation and configuration through constructor / setup objects / parameters.
 */
class DSConfig {
    /**
     * Retrieve a service from config, by name.
     *
     * Services can be provided (first present is taken)
     * - using name_class in object methods (an instance is created, using config as constructor argument)
     * - using name_provider if object properties (the service is retrieved using provide(config) method from provider)
     * - using object setup[name] property : instance is directly used
     * - using object setup[name_class] property (an instance is created, using config as constructor arguments)
     * - using object setup[name_provider] property (service instance is retrieved using provide(config))
     *
     * if no instance can be found, an error is thrown
     *
     * @param name : service name
     * @param config : config values
     * @param store : if true, store result in _name property
     * @returns service instance
     */
    get_service(name, config, store = true) {
        if (!this["_" + name] || !store) {
            let result;
            if (this[name + "_class"]) {
                result = new this[name + "_class"](config);
            }
            else if (this[name + "_provider"]) {
                result = this[name + "_provider"].withConfig(config);
            }
            else if (this.setup[name]) {
                result = this.setup[name];
            }
            else if (this.setup[name + "_class"]) {
                result = new this.setup[name + "_class"](config);
            }
            else if (this.setup[name + "_provider"]) {
                const provider = this.setup[name + "_provider"];
                result = provider.withConfig(config);
            }
            else {
                throw new Error(name + " service is not defined");
            }
            if (store) {
                this["_" + name] = result;
            }
            else {
                return result;
            }
        }
        return this["_" + name];
    }
    /**
     * Retrieve service configuration values :
     *
     * - from name_config property on collection
     * - from setup[name_config] property
     *
     * @param name service name
     * @returns  service configuration (null if no config found)
     */
    get_service_config(name) {
        if (this[name + "_config"]) {
            return this[name + "_config"];
        }
        else if (this.setup[name + "_config"]) {
            return this.setup[name + "_config"];
        }
        else {
            return null;
        }
    }
}

class IDSQuerysetSetup {
}
const QUERYSET_SETUP_NAMES = [
    "paginator", "paginator_class", "paginator_provider", "paginator_config",
    "filter", "filter_class", "filter_provider", "filter_config",
    "sorter", "sorter_class", "sorter_provider", "sorter_config"
];
class DSQueryset extends DSConfig {
    constructor(collection, setup = {}) {
        super();
        this.collection = collection;
        this.context = {};
        this._results = new ReplaySubject(1);
        this._fields = [];
        // Setup is created from 1) this.setup, 2) collection properties 3) collection setup values
        this.setup = defaults(setup, pick(collection, QUERYSET_SETUP_NAMES), collection.setup || {});
        this.results = this._results.asObservable();
    }
    get filter() {
        return this.get_service("filter", this.get_filter_config());
    }
    get sorter() {
        return this.get_service("sorter", this.get_sorter_config());
    }
    get paginator() {
        return this.get_service("paginator", this.get_paginator_config());
    }
    all(params = {}) {
        return this.get(params);
    }
    paginate(params) {
        this.paginator.update(params);
        return this;
    }
    sort(params) {
        this.sorter.update(params);
        return this;
    }
    query(params) {
        this.filter.update(params);
        return this;
    }
    fields(fields) {
        this._fields = fields;
        return this;
    }
    get(params = {}) {
        const context = extend({}, params.context || {}, this.context || {}, this.collection.context || {});
        if (params.fromcache) {
            return of(this.collection.persistence.list(this.filter.localFilter, this.sorter.localSorter, { context }));
        }
        else {
            const searchArgs = {
                context
            };
            merge(searchArgs, this.filter.backendFilter(), this.paginator.backendPaginate(), this.sorter.backendSorter());
            merge(searchArgs.query, params.query || {});
            merge(searchArgs.query, this.fieldsQuery(searchArgs.query));
            const search = this.collection.adapter.list(searchArgs);
            return this.collection.backend.list(search, { context })
                .pipe(map((result) => {
                const pagination = this.paginator.getPaginationInfos(result, { context });
                const items = this.paginator.getResults(result, { context });
                const _items = [];
                for (const item of items) {
                    const itemdata = this.collection.serializer.deserialize(item, { context });
                    const temp = new this.collection.model(this.collection, itemdata, context);
                    const identifier = this.collection.adapter.retrieve(temp, { context });
                    const instance = this.collection.persistence.retrieve(identifier, { context });
                    if (instance) {
                        instance.assign(itemdata, context);
                        this.collection.persistence.save(identifier, instance, { context });
                        _items.push(instance);
                    }
                    else {
                        this.collection.persistence.save(identifier, temp, { context });
                        _items.push(temp);
                    }
                }
                // TODO: save persistences of results ids ?
                const output = { items: _items, pagination };
                this._results.next(output);
                return output;
            }));
        }
    }
    /**
     * Merge queryset fields params to "fields" query parameter.
     * If no field is given for queryset, return query as is.
     *
     * @param query request query.
     */
    fieldsQuery(query) {
        if (!this._fields || this._fields.length === 0) {
            return query;
        }
        if (query.fields) {
            query.fields = (query.fields.split(",").concat(this._fields)).join(",");
        }
        else {
            query.fields = this._fields.join(",");
        }
        return query;
    }
    get_filter_config() {
        return this.get_service_config("filter");
    }
    get_sorter_config() {
        return this.get_service_config("sorter");
    }
    get_paginator_config() {
        return this.get_service_config("paginator");
    }
}

class DSCollection extends DSConfig {
    constructor(setup = {}, context = {}) {
        super();
        this.setup = defaults(this.setup || {}, setup);
        this.context = context;
        this.init();
    }
    get adapter() {
        return this.get_service("adapter", this.get_adapter_config());
    }
    set adapter(ad) {
        this._adapter = ad;
    }
    get backend() {
        return this.get_service("backend", this.get_backend_config());
    }
    set backend(bk) {
        this._backend = bk;
    }
    get serializer() {
        return this.get_service("serializer", this.get_serializer_config());
    }
    set serializer(sr) {
        this._serializer = sr;
    }
    get persistence() {
        return this.get_service("persistence", this.get_persistence_config());
    }
    set persistence(ps) {
        this._persistence = ps;
    }
    get queryset() {
        return new DSQueryset(this, this.get_queryset_config());
    }
    // CONFIGURATION
    init() {
        return null;
    }
    create(values = {}, params = {}) {
        const context = extend({}, this.context, params.context || {});
        const instance = new this.model(this, {}, context);
        const validation = instance.assign(values, context, params.validate, params.asyncValidate);
        if (validation !== true) {
            return throwError(validation);
        }
        if (params.save) {
            return this.save(instance);
        }
        else if (!params.volatile) {
            this.persistence.save(this.adapter.create(instance, { create: true, context }), instance);
            return of(instance);
        }
        else {
            return of(instance);
        }
    }
    save(instance, params = {}) {
        const context = extend({}, this.context, instance._context);
        const validation = instance.validate("__all__", null, params.asyncValidate);
        if (validation !== true) {
            return throwError(validation);
        }
        if (instance._pk === null || instance.id === undefined) {
            // Pk is not defined, let"s save this item
            const identifier = this.adapter.create(instance, { create: true, context });
            const tosave = this.serializer.serialize(instance, context, []);
            return this.backend.create(identifier, tosave, { context, validate: params.validate, asyncValidate: params.asyncValidate })
                .pipe(map((fromdb) => {
                instance.assign(this.serializer.deserialize(fromdb, { context }), context, params.validate, params.asyncValidate);
                return instance;
            }));
        }
        else {
            // Identifier is defined, it"s a full update
            return this.update(instance, [], { validate: params.validate, asyncValidate: params.asyncValidate });
        }
    }
    update(instance, fields = [], params = {}) {
        const context = extend({}, this.context, instance._context);
        const validation = instance.validate(fields, null, params.asyncValidate);
        if (validation !== true) {
            return throwError(validation);
        }
        const partial = fields.length > 0;
        const identifier = this.adapter.update(instance, partial, { context });
        if (identifier) {
            const tosave = this.serializer.serialize(instance, context, fields);
            if (fields.length > 0) {
                return this.backend.partial_update(identifier, tosave, { context })
                    .pipe(map((fromdb) => {
                    instance.assign(this.serializer.deserialize(fromdb, { context }), context, params.validate, params.asyncValidate);
                    this.persistence.save(identifier, instance, { context });
                    return instance;
                }));
            }
            else {
                return this.backend.update(identifier, tosave, { context })
                    .pipe(map((fromdb) => {
                    instance.assign(this.serializer.deserialize(fromdb, { context }), context, params.validate, params.asyncValidate);
                    this.persistence.save(identifier, instance, { context });
                    return instance;
                }));
            }
        }
        return throwError("Cannot update unsaved item");
    }
    // SEE: use params for query/headers ?
    remove(instance, params = {}) {
        const context = extend({}, this.context, instance._context);
        const identifier = this.adapter.destroy(instance, { context, query: params.query });
        if (identifier) {
            return this.backend.destroy(identifier, { context })
                .pipe(tap(() => {
                this.persistence.destroy(identifier, { context });
            }));
        }
        return throwError("Cannot delete unsaved item");
    }
    refresh(instance, params = {}) {
        const context = extend({}, this.context, instance._context);
        const identifier = this.adapter.retrieve(instance, { context, query: params.query });
        if (identifier) {
            return this.backend.retrieve(identifier, { context })
                .pipe(map((fromdb) => {
                instance.assign(this.serializer.deserialize(fromdb, { context }), context);
                this.persistence.save(identifier, instance, { context });
                return instance;
            }));
        }
        throw new Error("Cannot refresh unsaved item");
    }
    get(pk, params = {}) {
        const context = extend({}, this.context, params.context || {});
        const identifier = this.adapter.retrieve(pk, { options: params.options, context, query: params.query });
        if (identifier === null) {
            throw new Error("Unknown identifier, from " + pk);
        }
        if (params.fromcache) {
            const out = this.persistence.retrieve(identifier, { context });
            if (out) {
                return of(out);
            }
        }
        return this.backend.retrieve(identifier, { context })
            .pipe(mergeMap((instdata) => {
            const instance = this.persistence.retrieve(identifier, { context });
            if (!instance) {
                return this.create(this.serializer.deserialize(instdata, { context }), { context, validate: params.validate, asyncValidate: params.asyncValidate });
            }
            else {
                instance.assign(this.serializer.deserialize(instdata, { context }), { context }, { validate: params.validate, asyncValidate: params.asyncValidate });
                this.persistence.save(identifier, instance, { context });
                return of(instance);
            }
        }));
    }
    action(instance, action, args) {
        const cargs = (isString(args) ? { body: {}, method: "POST" } : args);
        const context = extend({}, this.context, cargs.context || {});
        const actargs = extend({}, cargs, { context });
        let identifier;
        if (instance === null) {
            identifier = this.adapter.list_action(action, actargs);
        }
        else {
            identifier = this.adapter.detail_action(instance, action, actargs);
        }
        return this.backend.action(identifier, actargs.method, actargs.body, actargs);
    }
    get_queryset_config() {
        return this;
    }
    get_adapter_config() {
        return this.get_service_config("adapter");
    }
    get_backend_config() {
        return this.get_service_config("backend");
    }
    get_serializer_config() {
        return this.get_service_config("serializer");
    }
    get_persistence_config() {
        return this.get_service_config("persistence");
    }
}

const DS_FILTER_QUERY_CONFIG = new InjectionToken("filter.queryfilter.config");
class DSQueryFilterService {
    constructor(params = null) {
        this.fields = {};
        this._common = {};
        // noinspection JSUnusedLocalSymbols
        this.localFilter = (item) => {
            // TODO: implement local filter
            console.warn("Local filter : NOT IMPLEMENTED");
            return true;
        };
        if (params) {
            this._common = params.common || {};
        }
        else {
            this._common = {};
        }
    }
    backendFilter() {
        const fields = clone(this.fields);
        extend(fields, this._common);
        const out = {};
        for (const f of Object.keys(fields)) {
            const v = fields[f];
            if (isObject(v) && v.name) {
                const vo = v;
                let k = vo.name;
                if (vo.operation) {
                    k += "__" + vo.operation;
                }
                out[k] = this.valueToQuery(vo.value);
            }
            else {
                out[f] = this.valueToQuery(v);
            }
        }
        return { query: out };
    }
    update(filter_params, partial = false) {
        if (partial) {
            assign(this.fields, filter_params);
        }
        else {
            this.fields = filter_params;
        }
    }
    valueToQuery(v) {
        if (isBoolean(v)) {
            if (v) {
                return "1";
            }
            return "0";
        }
        if (isNumber(v)) {
            return v.toString();
        }
        if (isDate(v)) {
            return v.toString();
        }
        if (isString(v)) {
            return v;
        }
        return JSON.stringify(v);
    }
}
DSQueryFilterService.ɵfac = function DSQueryFilterService_Factory(t) { return new (t || DSQueryFilterService)(ɵngcc0.ɵɵinject(DS_FILTER_QUERY_CONFIG, 8)); };
DSQueryFilterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSQueryFilterService, factory: DSQueryFilterService.ɵfac });
DSQueryFilterService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_FILTER_QUERY_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSQueryFilterService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_FILTER_QUERY_CONFIG]
            }] }]; }, null); })();
class DSQueryFilterProvider {
    constructor(params = null) {
        this.params = params;
    }
    withConfig(params = null) {
        return new DSQueryFilterService(params || this.params);
    }
}
DSQueryFilterProvider.ɵfac = function DSQueryFilterProvider_Factory(t) { return new (t || DSQueryFilterProvider)(ɵngcc0.ɵɵinject(DS_FILTER_QUERY_CONFIG, 8)); };
DSQueryFilterProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSQueryFilterProvider, factory: DSQueryFilterProvider.ɵfac });
DSQueryFilterProvider.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_FILTER_QUERY_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSQueryFilterProvider, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_FILTER_QUERY_CONFIG]
            }] }]; }, null); })();

const DS_PAGINATOR_PAGE_CONFIG = new InjectionToken("paginator.page.config");
class DSPagePaginatorService {
    constructor(_config = null) {
        this._config = _config;
        this.page = 1;
        if (this._config === null) {
            this._config = {};
        }
        this.clear();
    }
    getPaginationInfos(result) {
        // TODO: parametrize response keys used to retrieve infos
        if (result.nav) {
            this.page = result.nav.page;
            this.page_size = result.nav.size;
            return { nav: result.nav, parameters: result.parameters };
        }
        else {
            return {};
        }
    }
    getResults(results) {
        // TODO: parametrize response keys used to retrieve infos
        if (results.nav) {
            return results.results;
        }
        else {
            return results;
        }
    }
    update(params) {
        // TODO: update page number on page_size change ?
        if (params.page) {
            this.page = params.page;
        }
        if (params.page_size) {
            this.page_size = params.page_size;
        }
    }
    clear() {
        this.page = this._config.page || 1;
        this.page_size = this._config.page_size || null;
        this.page_parameter = this._config.page_parameter || "page";
        this.page_size_parameter = this._config.page_size_parameter || "page_size";
    }
    backendPaginate(page = null, page_size = null) {
        const pagination = {};
        if (page || this.page) {
            pagination[this.page_parameter] = page || this.page || 1;
        }
        if (page_size || this.page_size) {
            pagination[this.page_size_parameter] = page_size || this.page_size || 20;
        }
        return { query: pagination };
    }
    localPaginate() {
        console.error("Page paginator local not implemented");
        return false;
    }
}
DSPagePaginatorService.ɵfac = function DSPagePaginatorService_Factory(t) { return new (t || DSPagePaginatorService)(ɵngcc0.ɵɵinject(DS_PAGINATOR_PAGE_CONFIG, 8)); };
DSPagePaginatorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSPagePaginatorService, factory: DSPagePaginatorService.ɵfac });
DSPagePaginatorService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_PAGINATOR_PAGE_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSPagePaginatorService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_PAGINATOR_PAGE_CONFIG]
            }] }]; }, null); })();
class DSPagePaginatorProvider {
    constructor(_config = null) {
        this._config = _config;
    }
    withConfig(params = null) {
        return new DSPagePaginatorService(params || this._config);
    }
}
DSPagePaginatorProvider.ɵfac = function DSPagePaginatorProvider_Factory(t) { return new (t || DSPagePaginatorProvider)(ɵngcc0.ɵɵinject(DS_PAGINATOR_PAGE_CONFIG, 8)); };
DSPagePaginatorProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSPagePaginatorProvider, factory: DSPagePaginatorProvider.ɵfac });
DSPagePaginatorProvider.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_PAGINATOR_PAGE_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSPagePaginatorProvider, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_PAGINATOR_PAGE_CONFIG]
            }] }]; }, null); })();

class DSMemoryPersistence {
    constructor() {
        this.type = "OBJ";
        this._items = {};
    }
    save(identifier, data) {
        const id = JSON.stringify(identifier);
        this._items[id] = data;
        return this._items[id];
    }
    retrieve(identifier) {
        const id = JSON.stringify(identifier);
        return this._items[id];
    }
    destroy(identifier) {
        const id = JSON.stringify(identifier);
        delete this._items[id];
    }
    list(lfilter = null, sorter = null) {
        // TODO: add pagination
        let items;
        if (isFunction(lfilter)) {
            items = filter(values(this._items), lfilter);
        }
        else {
            items = values(this._items);
        }
        if (isFunction(sorter)) {
            items.sort(sorter);
        }
        return items;
    }
    clear(params = {}) {
        this._items = {};
    }
}
DSMemoryPersistence.ɵfac = function DSMemoryPersistence_Factory(t) { return new (t || DSMemoryPersistence)(); };
DSMemoryPersistence.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSMemoryPersistence, factory: DSMemoryPersistence.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSMemoryPersistence, [{
        type: Injectable
    }], function () { return []; }, null); })();

class DSDefaultSerializer {
    serialize(instance, context = {}, fields = []) {
        let obj;
        if (fields.length > 0) {
            obj = pick(instance, fields);
        }
        else {
            obj = instance;
        }
        const data = omitBy(obj, (value, key) => (key[0] === "_") || (key[0] === "$") || key[key.length - 1] === "$");
        for (const k of Object.keys(data)) {
            if (instance._fields && instance._fields[k] && instance._fields[k].serialize) {
                data[k] = instance._fields[k].serialize(data[k]);
            }
        }
        return data;
    }
    deserialize(values) {
        return values;
    }
    serializeMany(instances, context = {}, fields = []) {
        const serialized = [];
        for (const instance of instances) {
            serialized.push(this.serialize(instance, context, fields));
        }
        return serialized;
    }
    deserializeMany(result) {
        const deserialized = [];
        for (const res of result) {
            deserialized.push(this.deserialize(res));
        }
        return deserialized;
    }
}
DSDefaultSerializer.ɵfac = function DSDefaultSerializer_Factory(t) { return new (t || DSDefaultSerializer)(); };
DSDefaultSerializer.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSDefaultSerializer, factory: DSDefaultSerializer.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSDefaultSerializer, [{
        type: Injectable
    }], null, null); })();
class DSDefaultSerializerProvider {
    provide(params) {
        return new DSDefaultSerializer();
    }
}
DSDefaultSerializerProvider.ɵfac = function DSDefaultSerializerProvider_Factory(t) { return new (t || DSDefaultSerializerProvider)(); };
DSDefaultSerializerProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSDefaultSerializerProvider, factory: DSDefaultSerializerProvider.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSDefaultSerializerProvider, [{
        type: Injectable
    }], null, null); })();

const DS_SORT_QUERY_PARAM = new InjectionToken("sort.default.queryparam");
class DSQuerySorterService {
    /**
     * Constructor.
     * Stores query_param name (default = ordering) using DS_SORT_QUERY_PARAM injection token (sort.default.queryparam)
     *
     * @param  query_param
     */
    constructor(query_param = null) {
        this.query_param = query_param;
        this.fields = [];
        /**
         * Comparison function for 2 items, using fields & direction rules.
         *
         * @param item1 item1 to be compared
         * @param item2 item2 to be compared
         * @returns  1 if item2 created than item1, -1 if lower, 0 if equal.
         */
        this.localSorter = (item1, item2) => {
            for (const f of this.fields) {
                if (item1[f.field] > item2[f.field]) {
                    if (f.direction === "asc") {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
                else if (item1[f.field] < item2[f.field]) {
                    if (f.direction === "asc") {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                }
            }
            return 0;
        };
        if (this.query_param === null) {
            this.query_param = "ordering";
        }
    }
    /**
     * Update sorting parameters.
     *
     * @param sorter_params : list of {field: string, direction: 'asc'|'desc', emptyfirst?: true|false}
     */
    update(sorter_params) {
        this.fields = [];
        for (const sortitem of sorter_params) {
            this.fields.push({ field: sortitem.field, direction: sortitem.direction, emptyfirst: sortitem.emptyfirst });
        }
    }
    /**
     * Clear all sorting parameters.
     */
    clear() {
        this.fields = [];
    }
    /**
     * Returns sorter parameters in adapter syntax.
     * Default implementation returns a query string in DS_SORT_QUERY_PARAM: [direction]fieldname,[direction]fieldname syntax.
     * Example : `{query: {ordering: "+name,-age"}}`
     *
     * @returns  query: { DS_SORT_QUERY_PARAM: [direction]fieldname,[direction]fieldname syntax }
     */
    backendSorter() {
        const out = [];
        for (const f of this.fields) {
            if (f.direction === "asc") {
                out.push("+" + f.field);
            }
            else {
                out.push("-" + f.field);
            }
            if (f.emptyfirst) {
                console.warn("Empty first / last sorting not implemented");
            }
        }
        const q = { query: {} };
        q.query[this.query_param] = out.join(",");
        return q;
    }
}
DSQuerySorterService.ɵfac = function DSQuerySorterService_Factory(t) { return new (t || DSQuerySorterService)(ɵngcc0.ɵɵinject(DS_SORT_QUERY_PARAM, 8)); };
DSQuerySorterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSQuerySorterService, factory: DSQuerySorterService.ɵfac });
DSQuerySorterService.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [DS_SORT_QUERY_PARAM,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSQuerySorterService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_SORT_QUERY_PARAM]
            }] }]; }, null); })();
class DSQuerySorterProvider {
    constructor(query_param = null) {
        this.query_param = query_param;
    }
    withConfig(params = null) {
        return new DSQuerySorterService(params || this.query_param);
    }
}
DSQuerySorterProvider.ɵfac = function DSQuerySorterProvider_Factory(t) { return new (t || DSQuerySorterProvider)(ɵngcc0.ɵɵinject(DS_SORT_QUERY_PARAM, 8)); };
DSQuerySorterProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSQuerySorterProvider, factory: DSQuerySorterProvider.ɵfac });
DSQuerySorterProvider.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [DS_SORT_QUERY_PARAM,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSQuerySorterProvider, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_SORT_QUERY_PARAM]
            }] }]; }, null); })();

const DS_REST_ADAPTER_PROVIDER = new InjectionToken("ds.rest.adapter.provider");
const DS_REST_PERSISTENCE = new InjectionToken("ds.rest.persistence");
const DS_REST_SERIALIZER = new InjectionToken("ds.rest.serializer");
const DS_REST_BACKEND = new InjectionToken("ds.rest.backend");
const DS_REST_QUERYSET_SORTER = new InjectionToken("ds.rest.queryset.sorter.provider");
const DS_REST_QUERYSET_FILTER = new InjectionToken("ds.rest.queryset.filter.provider");
const DS_REST_QUERYSET_PAGINATOR = new InjectionToken("ds.rest.queryset.paginator.provider");
const DS_REST_COLLECTION_SETUP = new InjectionToken("ds.rest.collection.setup");
class DSRestCollectionBaseSetup {
    constructor(backend, adapter_provider, persistence, serializer, sorter_provider, filter_provider, paginator_provider) {
        this.backend = backend;
        this.adapter_provider = adapter_provider;
        this.persistence = persistence;
        this.serializer = serializer;
        this.sorter_provider = sorter_provider;
        this.filter_provider = filter_provider;
        this.paginator_provider = paginator_provider;
    }
}
DSRestCollectionBaseSetup.ɵfac = function DSRestCollectionBaseSetup_Factory(t) { return new (t || DSRestCollectionBaseSetup)(ɵngcc0.ɵɵinject(DSRestBackend), ɵngcc0.ɵɵinject(DSRestUrlAdapterProvider), ɵngcc0.ɵɵinject(DSMemoryPersistence), ɵngcc0.ɵɵinject(DSDefaultSerializer), ɵngcc0.ɵɵinject(DSQuerySorterProvider), ɵngcc0.ɵɵinject(DSQueryFilterProvider), ɵngcc0.ɵɵinject(DSPagePaginatorProvider)); };
DSRestCollectionBaseSetup.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestCollectionBaseSetup, factory: DSRestCollectionBaseSetup.ɵfac });
DSRestCollectionBaseSetup.ctorParameters = () => [
    { type: DSRestBackend },
    { type: DSRestUrlAdapterProvider },
    { type: DSMemoryPersistence },
    { type: DSDefaultSerializer },
    { type: DSQuerySorterProvider },
    { type: DSQueryFilterProvider },
    { type: DSPagePaginatorProvider }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestCollectionBaseSetup, [{
        type: Injectable
    }], function () { return [{ type: DSRestBackend }, { type: DSRestUrlAdapterProvider }, { type: DSMemoryPersistence }, { type: DSDefaultSerializer }, { type: DSQuerySorterProvider }, { type: DSQueryFilterProvider }, { type: DSPagePaginatorProvider }]; }, null); })();
class DSRestCollectionSetup {
    constructor(backend, adapter_provider, persistence, serializer, sorter_provider, filter_provider, paginator_provider) {
        this.backend = backend;
        this.adapter_provider = adapter_provider;
        this.persistence = persistence;
        this.serializer = serializer;
        this.sorter_provider = sorter_provider;
        this.filter_provider = filter_provider;
        this.paginator_provider = paginator_provider;
    }
}
DSRestCollectionSetup.ɵfac = function DSRestCollectionSetup_Factory(t) { return new (t || DSRestCollectionSetup)(ɵngcc0.ɵɵinject(DS_REST_BACKEND, 8), ɵngcc0.ɵɵinject(DS_REST_ADAPTER_PROVIDER, 8), ɵngcc0.ɵɵinject(DS_REST_PERSISTENCE, 8), ɵngcc0.ɵɵinject(DS_REST_SERIALIZER, 8), ɵngcc0.ɵɵinject(DS_REST_QUERYSET_SORTER, 8), ɵngcc0.ɵɵinject(DS_REST_QUERYSET_FILTER, 8), ɵngcc0.ɵɵinject(DS_REST_QUERYSET_PAGINATOR, 8)); };
DSRestCollectionSetup.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestCollectionSetup, factory: DSRestCollectionSetup.ɵfac });
DSRestCollectionSetup.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_BACKEND,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_ADAPTER_PROVIDER,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_PERSISTENCE,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_SERIALIZER,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_QUERYSET_SORTER,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_QUERYSET_FILTER,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_REST_QUERYSET_PAGINATOR,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestCollectionSetup, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_BACKEND]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_ADAPTER_PROVIDER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_PERSISTENCE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_SERIALIZER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_QUERYSET_SORTER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_QUERYSET_FILTER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_REST_QUERYSET_PAGINATOR]
            }] }]; }, null); })();
class DSRestCollectionSetupProvider {
    constructor(base, tok) {
        assign(this, tok, base);
    }
}
DSRestCollectionSetupProvider.ɵfac = function DSRestCollectionSetupProvider_Factory(t) { return new (t || DSRestCollectionSetupProvider)(ɵngcc0.ɵɵinject(DSRestCollectionBaseSetup), ɵngcc0.ɵɵinject(DSRestCollectionSetup)); };
DSRestCollectionSetupProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestCollectionSetupProvider, factory: DSRestCollectionSetupProvider.ɵfac });
DSRestCollectionSetupProvider.ctorParameters = () => [
    { type: DSRestCollectionBaseSetup },
    { type: DSRestCollectionSetup }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestCollectionSetupProvider, [{
        type: Injectable
    }], function () { return [{ type: DSRestCollectionBaseSetup }, { type: DSRestCollectionSetup }]; }, null); })();
// FIXME: removed "context" constructor, but may be needed...
class DSRestCollection extends DSCollection {
    constructor(setup) {
        super(setup, {});
        this.setup = setup;
    }
}
DSRestCollection.ɵfac = function DSRestCollection_Factory(t) { return new (t || DSRestCollection)(ɵngcc0.ɵɵinject(DSRestCollectionSetupProvider)); };
DSRestCollection.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DSRestCollection, factory: DSRestCollection.ɵfac });
DSRestCollection.ctorParameters = () => [
    { type: DSRestCollectionSetupProvider }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestCollection, [{
        type: Injectable
    }], function () { return [{ type: DSRestCollectionSetupProvider }]; }, null); })();
class DSRestQueryset extends DSQueryset {
    constructor(collection, setup = {}) {
        super(collection, setup);
        this.collection = collection;
        this.setup = setup;
    }
}

const DSBaseFieldSerializer = v => v;
const setField = (target, key, field) => {
    if (!Object.getOwnPropertyDescriptor(target, "__fields")) {
        target.__fields = {};
    }
    target.__fields[key] = field;
    const parentTarget = Object.getPrototypeOf(target);
    const parentData = parentTarget.__fields;
    if (parentData) {
        Object.keys(parentData).forEach((k) => {
            if (!target.__fields[k] && k !== key) {
                target.__fields[k] = parentData[k];
            }
        });
    }
};
class DSField {
    constructor(params) {
        this.validators = [];
        this.asyncValidators = [];
        this.many = false;
        Object.assign(this, params);
    }
    validate(value, many = null) {
        const errors = {};
        let haveErrors = false;
        if (many === null) {
            return this.validate(value, this.many);
        }
        if (many) {
            for (const val of value) {
                const result = this.validate(val, false);
                if (result !== null) {
                    return result;
                }
            }
        }
        else {
            for (const v of this.validators) {
                const result = v({ value });
                if (result !== null) {
                    Object.assign(errors, result);
                    haveErrors = true;
                }
            }
            if (!haveErrors) {
                return null;
            }
            return errors;
        }
    }
    serialize(value, many = null) {
        if (many === null) {
            this.serialize(value, this.many);
        }
        if (many) {
            const result = [];
            for (const val of value) {
                result.push(this.serialize(val, false));
            }
            return result;
        }
        if (!this.serializer) {
            return DSBaseFieldSerializer(value);
        }
        return this.serializer(value);
    }
}

const DSAutoField = (params = {}) => (target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    Object.assign(params, {
        name: key,
        type: "autofield",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSBooleanField = (params = {}) => (target, key) => {
    // SEE: add boolean type validator ?
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    Object.assign(params, {
        name: key,
        type: "booleanfield",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const choicesValidator = (allowed) => (c) => {
    if (allowed.indexOf(c.value) >= 0) {
        return null;
    }
    return { choices: { allowed, actual: c.value } };
};

const charBaseField = (params, type, addvalidators, target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    for (const v of addvalidators) {
        validators.push(v);
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    if (params.minLength !== null && params.minLength !== undefined) {
        validators.push(Validators.minLength(params.minLength));
    }
    if (params.maxLength !== null && params.maxLength !== undefined) {
        validators.push(Validators.maxLength(params.maxLength));
    }
    if (params.choices !== null && params.choices !== undefined && params.choices.length !== 0) {
        const choices = map$1(params.choices, (item) => item[0]);
        validators.push(choicesValidator(choices));
    }
    if (params.pattern !== null && params.pattern !== undefined) {
        validators.push(Validators.pattern(params.pattern));
    }
    Object.assign(params, {
        name: key,
        type,
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};
// eslint-disable-next-line max-len
const DSCharField = (params = {}) => (target, key) => charBaseField(params, "charfield", [], target, key);

const DSDateField = (params = {}) => (target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    const serializer = (value) => {
        // If value is date instance, return only yyyy-mm-dd
        if (value && value.getFullYear) {
            return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`;
        }
        else {
            // If not a date instante, return the value directly
            return value;
        }
    };
    Object.assign(params, {
        name: key,
        type: "datefield",
        validators,
        serializer
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSDateTimeField = (params = {}) => (target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    Object.assign(params, {
        name: key,
        type: "datetimefield",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSDefaultField = (params = {}) => (target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    Object.assign(params, {
        name: key,
        type: "defaultfield",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSEmailField = (params = {}) => (target, key) => {
    const validators = params.validateEmail === false ? [] : [Validators.email];
    return charBaseField(params, "emailfield", validators, target, key);
};

const DSForeignKeyField = (params = {}) => (target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    Object.assign(params, {
        name: key,
        type: "foreignkey",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSManyToManyField = (params = {}) => (target, key) => {
    // Set validators
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    Object.assign(params, {
        name: key,
        type: "manytomanyfield",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSPasswordField = (params = {}) => (target, key) => {
    // TODO: implement / find some password validation rules for passwordRules
    const validators = params.validatePassword ? [Validators.minLength(8)] : [];
    return charBaseField(params, "passwordfield", validators, target, key);
};

const DSSlugField = (params = {}) => (target, key) => {
    const validators = (params.validateSlug !== false) ? [Validators.pattern(/^[a-zA-Z0-9_-]+$/)] : [];
    return charBaseField(params, "slugfield", validators, target, key);
};

// eslint-disable-next-line max-len
const DSTextField = (params) => (target, key) => charBaseField(params, "textfield", [], target, key);

const DSDecimalField = (params = {}) => (target, key) => {
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    if (params.min !== undefined) {
        validators.push(Validators.min(params.min));
    }
    if (params.max !== undefined) {
        validators.push(Validators.max(params.max));
    }
    Object.assign(params, {
        name: key,
        type: "decimalfield",
        factor: params.factor || 1,
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

const DSIntegerField = (params = {}) => (target, key) => {
    let validators = [];
    if (params.validators) {
        validators = params.validators;
    }
    if (params.required) {
        validators.push(Validators.required);
    }
    if (params.min !== undefined) {
        validators.push(Validators.min(params.min));
    }
    if (params.max !== undefined) {
        validators.push(Validators.max(params.max));
    }
    Object.assign(params, {
        name: key,
        type: "integerfield",
        validators,
    });
    const field = new DSField(params);
    setField(target, key, field);
};

// From http://codes-sources.commentcamarche.net/source/16330-verification-de-la-validite-des-codes-siret-et-siren-algo-de-luhn
/**
 @name isValidSiren
 @param siren  Le code SIREN dont on veut vérifier la validité.
 @return  Un booléen qui vaut 'true' si le code SIREN passé en paramètre est valide, false sinon.
 */
const isValidSiren = siren => {
    let estValide;
    if ((siren.length !== 9) || (isNaN(siren))) {
        estValide = false;
    }
    else {
        // Donc le SIREN est un numérique à 9 chiffres
        let somme = 0;
        let tmp;
        for (let cpt = 0; cpt < siren.length; cpt++) {
            if ((cpt % 2) === 1) { // Les positions paires : 2ème, 4ème, 6ème et 8ème chiffre
                tmp = siren.charAt(cpt) * 2; // On le multiplie par 2
                if (tmp > 9) {
                    tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
                }
            }
            else {
                tmp = siren.charAt(cpt);
            }
            somme += parseInt(tmp, 10);
        }
        estValide = (somme % 10) === 0;
    }
    return estValide;
};
const ɵ0 = isValidSiren;
const sirenValidator = () => (c) => {
    if (isValidSiren(c.value)) {
        return null;
    }
    return { siren: true };
};
/**
 @name isSiretValid
 @param siret Le code SIRET dont on veut vérifier la validité.
 @return  Un booléen qui vaut 'true' si le code SIRET passé en
 paramètre est valide, false sinon.
 */
const isSiretValid = siret => {
    let estValide;
    if ((siret.length !== 14) || (isNaN(siret))) {
        estValide = false;
    }
    else {
        // Donc le SIRET est un numérique à 14 chiffres
        // Les 9 premiers chiffres sont ceux du SIREN (ou RCS), les 4 suivants
        // correspondent au numéro d'établissement
        // et enfin le dernier chiffre est une clef de LUHN.
        let somme = 0;
        let tmp;
        for (let cpt = 0; cpt < siret.length; cpt++) {
            if ((cpt % 2) === 0) { // Les positions impaires : 1er, 3è, 5è, etc...
                tmp = siret.charAt(cpt) * 2; // On le multiplie par 2
                if (tmp > 9) {
                    tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
                }
            }
            else {
                tmp = siret.charAt(cpt);
            }
            somme += parseInt(tmp, 10);
        }
        estValide = (somme % 10) === 0;
    }
    return estValide;
};
const ɵ1 = isSiretValid;
const siretValidator = () => (c) => {
    if (isSiretValid(c.value)) {
        return null;
    }
    return { siret: true };
};

// noinspection JSUnusedLocalSymbols
const DEFAULT_ASSIGN_OPTIONS = { validate: false, asyncValidate: false };
// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
/**
 * Data object base class.
 * Provides base functions for save, remove, refresh and update object based functions.
 */
class DSModel {
    /**
     * Construct object from (optional) value object.
     * WARNING: initialisation does not work if fields have default values.
     * See http://bit.ly/2cwApxb
     *
     * @param collection Object"s collection
     * @param values Initial values (not validated)
     * @param context Initial context (not validated)
     */
    constructor(collection = null, values = {}, context = {}) {
        this.assign(values, context);
        this.__collection = collection;
    }
    /**
     * _META access (read-only)
     *
     * @returns IDSModelMeta
     */
    get _META() {
        const out = {};
        defaults(out, this.__META, { pk_field: "id", validate_sync: true, validate_async: false });
        return out;
    }
    /**
     * _META setter.
     *
     * @param value IDSModelMeta
     */
    set _META(value) {
        this.__META = value;
    }
    /**
     * Get object collection.
     *
     * @returns IDSCollection<DSModel, any, any> collection or null if no collection present
     */
    get _collection() {
        if (this.__collection) {
            return this.__collection;
        }
        return null;
    }
    /**
     * Get object fields.
     *
     * @returns IDSFieldList
     */
    get _fields() {
        return this.__fields;
    }
    /**
     * Returns object primary key (from getPk()).
     *
     * @returns number|string
     */
    get _pk() {
        return this.getPk();
    }
    /**
     * Returns (and generate if needed) object local key (random string).
     *
     * @returns random string
     */
    get _local() {
        if (!this.__localId) {
            this.__localId = Math.random().toString(36).substring(2, 15) +
                Math.random().toString(36).substring(2, 15);
        }
        return this.__localId;
    }
    /**
     * Save object using collection save method.
     *
     * @see return value ?
     * @returns Observable<boolean>
     */
    save(params = {}) {
        this._checkCollection();
        return this.__collection.save(this, params);
    }
    /**
     * Save object using collection update method.
     *
     * @see return value ?
     * @returns Observable<boolean>
     */
    update(fields = [], params = {}) {
        this._checkCollection();
        return this.__collection.update(this, fields, params);
    }
    /**
     * Remove object using datacollection remove method.
     *
     * @see return value ?
     * @returns Observable<boolean>
     */
    destroy(params = {}) {
        this._checkCollection();
        return this.__collection.remove(this, params);
    }
    /**
     * Alias for destroy method.
     *
     * @see return value ?
     * @returns Observable<boolean>
     */
    remove(params = {}) {
        return this.destroy(params);
    }
    /**
     * Alias for destroy method.
     *
     * @see return value ?
     * @returns Observable<boolean>
     */
    delete(params = {}) {
        return this.destroy(params);
    }
    /**
     * Refresh object from datacollection.
     *
     * @see return value ?
     * @returns Observable<boolean>
     */
    refresh(params = {}) {
        this._checkCollection();
        return this.__collection.refresh(this, params);
    }
    // -------------------------------------------------------------------------------------------------------------------
    // Computed properties & getters for private properties
    /**
     * Makes action
     *
     * @param action string (method)
     * @param args string (url) or object {url, body}
     * @returns Observable<any>
     */
    action(action, args) {
        this._checkCollection();
        return this.__collection.action(this, action, args);
    }
    assign(values = null, context = null, validate = false, async = false) {
        if (context) {
            this._context = context;
        }
        if (values) {
            if (validate && async) {
                return this.validate(Object.keys(values), values, true)
                    .pipe(map((res) => {
                    if (res === true) {
                        for (const f of Object.keys(values)) {
                            this[f] = values[f];
                        }
                    }
                    return res;
                }));
            }
            else if (validate) {
                // Validate sync
                const val = this.validate(Object.keys(values), values, false);
                if (val === true) {
                    for (const f of Object.keys(values)) {
                        this[f] = values[f];
                    }
                }
                return val;
            }
            else {
                // No validation
                for (const f of Object.keys(values)) {
                    this[f] = values[f];
                }
                return async ? of(true) : true;
            }
        }
    }
    /**
     * Validate (sync/async) current object.
     *
     * @returns IDSValidationResult validation results
     */
    validate(fields = null, data = null, async = null) {
        if (fields === null) {
            fields = "__all__";
        }
        if (data === null) {
            data = this;
        }
        if (async === null) {
            async = this._META.validate_async;
        }
        if (fields === "__all__") {
            if (this.__fields) {
                fields = Object.keys(this.__fields);
            }
            else {
                fields = [];
            }
        }
        const sync = this.validateSync(fields, data);
        if (sync !== true) {
            return async ? of(sync) : sync;
        }
        if (async) {
            return this.validateAsync(fields, data);
        }
        else {
            return sync;
        }
    }
    /**
     * Helper toJSON that removes internal (and potentially circular) properties.
     *
     * @returns  model with _ and $ properties removed.
     */
    toJSON() {
        return omitBy(this, (value, key) => (key[0] === "_") || (key[0] === "$" || key[key.length - 1] === "$" || key[key.length - 1] === "_"));
    }
    // -------------------------------------------------------------------------------------------------------------------
    // Protected methods
    /**
     * Sync validate fields.
     */
    validateSync(fields, data) {
        const errors = {};
        let haveErrors = false;
        if (!this._fields) {
            console.warn("No fields for validation");
            return true;
        }
        for (const f of Object.keys(this._fields)) {
            if (fields.indexOf(f) >= 0) {
                const val = this._fields[f].validate(data[f]);
                if (val !== null) {
                    errors[f] = val;
                    haveErrors = true;
                }
            }
        }
        if (haveErrors) {
            console.warn("Have errors", errors);
            return errors;
        }
        return true;
    }
    /**
     * Async validate fields.
     */
    validateAsync(fields, data) {
        console.warn("Async validation not implemented");
        return of(true);
    }
    /**
     * Checks if object is associated to a datacollection, raises error if
     * no collection found.
     *
     * @returns boolean
     */
    _checkCollection() {
        if (!this.__collection) {
            throw new Error("No collection defined");
        }
        return true;
    }
    /**
     * Get primary key from object.
     *
     * @returns any
     */
    getPk() {
        return this["id"];
    }
}

// import { DSQuerySorterProvider } from "./sorters";
class DSRestModule {
}
DSRestModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DSRestModule });
DSRestModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DSRestModule_Factory(t) { return new (t || DSRestModule)(); }, providers: [
        DSRestUrlAdapterProvider,
        DSMemoryPersistence,
        DSDefaultSerializer,
        DSQuerySorterProvider,
        DSPagePaginatorProvider,
        DSQueryFilterProvider,
        DSRestCollectionBaseSetup,
        DSRestCollectionSetup,
        DSRestCollectionSetupProvider,
        DSRestBackend
    ], imports: [[
            CommonModule,
            HttpClientModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DSRestModule, { imports: function () { return [CommonModule,
        HttpClientModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DSRestModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule
                ],
                providers: [
                    DSRestUrlAdapterProvider,
                    DSMemoryPersistence,
                    DSDefaultSerializer,
                    DSQuerySorterProvider,
                    DSPagePaginatorProvider,
                    DSQueryFilterProvider,
                    DSRestCollectionBaseSetup,
                    DSRestCollectionSetup,
                    DSRestCollectionSetupProvider,
                    DSRestBackend
                ],
                declarations: []
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { COLLECTION_SETUP_NAMES, DSAutoField, DSBaseFieldSerializer, DSBooleanField, DSCharField, DSCollection, DSDateField, DSDateTimeField, DSDecimalField, DSDefaultField, DSDefaultSerializer, DSDefaultSerializerProvider, DSEmailField, DSField, DSForeignKeyField, DSIntegerField, DSManyToManyField, DSMemoryPersistence, DSModel, DSPagePaginatorProvider, DSPagePaginatorService, DSPasswordField, DSQueryFilterProvider, DSQueryFilterService, DSQuerySorterProvider, DSQuerySorterService, DSQueryset, DSRestBackend, DSRestCollection, DSRestCollectionBaseSetup, DSRestCollectionSetup, DSRestCollectionSetupProvider, DSRestModule, DSRestQueryset, DSRestUrlAdapter, DSRestUrlAdapterProvider, DSSlugField, DSTextField, DSTokenAuthentication, DS_FILTER_QUERY_CONFIG, DS_PAGINATOR_PAGE_CONFIG, DS_REST_ADAPTER_PROVIDER, DS_REST_BACKEND, DS_REST_BACKEND_AUTHENTICATOR, DS_REST_BACKEND_CONFIG, DS_REST_BACKEND_PARSER, DS_REST_BACKEND_RENDERER, DS_REST_COLLECTION_SETUP, DS_REST_PERSISTENCE, DS_REST_QUERYSET_FILTER, DS_REST_QUERYSET_PAGINATOR, DS_REST_QUERYSET_SORTER, DS_REST_SERIALIZER, DS_SORT_QUERY_PARAM, IDSQuerysetSetup, QUERYSET_SETUP_NAMES, REST_ADAPTER_CONFIG, charBaseField, choicesValidator, setField, sirenValidator, siretValidator, ɵ0$1 as ɵ0, ɵ1, DSConfig as ɵc };

//# sourceMappingURL=solidev-ngdataservice.js.map